<template>
  <div>
    <base-page-title :titleText="pageTitle" />
    <b-row class="no-gutters p-3">
      <b-button class="ml-auto" @click="triggerFileUpload">
        {{ $t("button.addPredictUserFromExternalProvider") }}
      </b-button>
      <input
        ref="csvFileInput"
        type="file"
        accept=".csv"
        style="display: none"
        @change="handleFileUpload"
      />
    </b-row>
    <b-col class="col-12 col-md-8 p-3 mx-auto">
      <client-list
        :externalProvider="'milano-fiere'"
      />
    </b-col>

    <!-- Service Selection Modal -->
    <select-services-modal
      :modalStatus="showServiceModal"
      @setModalStatus="showServiceModal = $event"
      @submit="handleServiceSelected"
    />

    <!-- User Preview Modal -->
    <client-batch-preview-modal
      :modalStatus="showPreviewModal"
      :users="parsedUsers"
      @setModalStatus="showPreviewModal = $event"
      @submit="createUsers"
    />
  </div>
</template>

<script>
import ClientList from "./../components/Client/ClientList";
import SelectServicesModal from "../components/ServicesPredict/SelectServicesModal.vue";
import ClientBatchPreviewModal from "../components/Client/ClientBatchPreviewModal.vue";
import Utils from "../Utils";

export default {
  components: {
    ClientList,
    SelectServicesModal,
    ClientBatchPreviewModal
  },
  data() {
    return {
      // pageTitle: "page.predict.title",
      pageTitle:"Milano Fiere clients (Foresight)",
      showServiceModal: false,
      showPreviewModal: false,
      parsedUsers: [],
      selectedServiceId: null
    };
  },
  methods: {
    triggerFileUpload() {
      this.$refs.csvFileInput.click();
    },
    
    async handleFileUpload(event) {
      const file = event.target.files[0];
      
      if (!file) return;
      
      if (!file.name.endsWith('.csv')) {
        this.$store.commit("error/SET_ERROR", {
          status: 400,
          messageText: "Please upload a CSV file"
        }, { root: true });
        return;
      }
      
      try {
        this.$store.commit("loader/SET_LOADER", {});
        
        this.parsedUsers = await Utils.parseCSV(file);
        
        // Add milano-fiere as default externalProvider
        this.parsedUsers = this.parsedUsers.map(user => ({
          ...user,
          externalProvider: 'milano-fiere'
        }));
        
        if (this.parsedUsers.length === 0) {
          this.$store.commit("error/SET_ERROR", {
            status: 400,
            messageText: "No valid users found in CSV"
          }, { root: true });
          return;
        }
        
        // Show service selection modal
        this.showServiceModal = true;
        
      } catch (error) {
        console.error('CSV parsing error:', error);
        this.$store.commit("error/SET_ERROR", {
          status: 400,
          messageText: "Failed to parse CSV file"
        }, { root: true });
      } finally {
        this.$store.dispatch("loader/close");
        // Reset file input
        event.target.value = '';
      }
    },
    
    handleServiceSelected(serviceId) {
      this.selectedServiceId = serviceId;
      this.showServiceModal = false;
      
      // Add serviceId to all users
      this.parsedUsers = this.parsedUsers.map(user => ({
        ...user,
        serviceId: serviceId
      }));
      
      // Show preview modal
      this.showPreviewModal = true;
    },
    
    async createUsers(users) {
      this.$store.commit("loader/SET_LOADER", {});
      
      try {
        // No transformation needed - flat structure matches schema
        await this.$store.dispatch("clients/createClientsBatch", users);
        
        // Success - close modal and refresh list
        this.showPreviewModal = false;
        this.parsedUsers = [];
        this.selectedServiceId = null;
        
        // Refresh client list
        await this.$store.dispatch("clients/retrieveClientsByType", "predict");
        
      } catch (error) {
        console.error('Batch creation error:', error);
      } finally {
        this.$store.dispatch("loader/close");
      }
    }
  }
};
</script>

<style scoped></style>